import { createFileRoute } from '@tanstack/react-router'
import Footer from '../components/landing/Footer'
import "./legal.css"

export const Route = createFileRoute('/help-center')({
  component: HelpCenterPage,
})

function HelpCenterPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Help Center</h1>
        
        <div className="legal-intro">
          <p>
            Find answers to frequently asked questions about Modulus Sell. If you can't find what you're looking for, feel free to contact us.
          </p>
        </div>

        <div className="legal-section">
          <h2>Frequently Asked Questions</h2>
          
          <h3>What is Modulus Sell and how does it help my business?</h3>
          <p>
            Modulus Sell is a mobile-first retail management platform designed to streamline your daily operations. We combine inventory tracking, high-speed QR scanning, and sales analytics into one intuitive dashboard, allowing you to spend less time on paperwork and more time growing your business.
          </p>

          <h3>Can I use Modulus Sell for multiple store locations?</h3>
          <p>
            Yes! Modulus Sell supports multi-store management. You can manage inventory, track sales, and view analytics across all your locations from a single dashboard.
          </p>

          <h3>How "real-time" are the analytics?</h3>
          <p>
            Our analytics update instantly as transactions occur. You'll see live data on sales, inventory levels, and profit margins the moment they happen.
          </p>

          <h3>Can Modulus Sell handle complex data flows?</h3>
          <p>
            Absolutely. Our platform is built to handle complex business workflows including multi-tier pricing, bulk operations, and advanced reporting needs.
          </p>

          <h3>What happens after my free trial ends?</h3>
          <p>
            You'll have the option to choose a plan that fits your business size. If you're not ready to subscribe, your data remains safe, but premium features like advanced analytics will be paused until you choose a plan.
          </p>

          <h3>How does the "Try Free for a Month" offer work?</h3>
          <p>
            Simply sign up and get full access to all features for 30 days. No credit card required. At the end of your trial, choose a plan that works for you.
          </p>
        </div>

        <div className="legal-section">
          <h2>Still need help?</h2>
          <p>
            Our support team is available to assist you.
          </p>
          <p>
            <strong>Email:</strong> <a href="mailto:sarfarazahmedkl@modulusseventeen.com">sarfarazahmedkl@modulusseventeen.com</a><br/>
            <strong>Phone:</strong> <a href="tel:+918078227271">+91 8078 227 271</a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  )
}
